import { HistoryBookingDetail } from '@user-history/entities/history-booking-detail';

export const abandonedReservationFeatureName = 'abandonedReservationModule';

export type UiAbandonedReservationState = Readonly<{
  isLoadingCancellation: boolean,
}>;

export type AbandonedReservationState = Readonly<{
  ui: UiAbandonedReservationState,
  abandonedReservation: HistoryBookingDetail,
}>;
